var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _vm.paineis && _vm.paineis.length > 0
        ? _c(
            "el-row",
            { staticClass: "new-project", attrs: { gutter: 20 } },
            [
              _c("card", {
                attrs: { isNewProject: true },
                on: { onClick: _vm.onClick }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.paineis && _vm.paineis.length > 0
        ? _c("listagem-paineis", {
            attrs: { paineis: _vm.paineis },
            on: { openModal: _vm.openModal, delete: _vm.deletePainel }
          })
        : _vm._e(),
      _c("validation-observer", { ref: "observer" }),
      _vm.modal
        ? _c("modal-cadastro-painel", {
            attrs: { idPainel: _vm.idPainel },
            on: {
              closeModal: function($event) {
                return _vm.closeModal()
              },
              refreshList: function($event) {
                return _vm.getMyPaineis()
              }
            }
          })
        : _vm._e(),
      _vm.paineis && _vm.paineis.length == 0
        ? _c(
            "div",
            [
              _c(
                "validation-observer",
                { ref: "observer" },
                [
                  _vm.modal
                    ? _c("modal-cadastro-painel", {
                        on: {
                          closeModal: function($event) {
                            return _vm.closeModal()
                          },
                          refreshList: function($event) {
                            return _vm.getMyPaineis()
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c("bem-vindo", { on: { openModal: _vm.openModal } })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5157d14b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5157d14b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/demandas/components/MeusPaineis.vue
// module id = null
// module chunks = 